import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { fonts } from '../../styles'

interface Props {
  offsetX: number
}

export const HandlerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
`

export const ChartWrapper = styled.div`
  height: 350px;
  padding-bottom: 45px;
  position: relative;
`

export const MonthWrapper = styled.div`
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 10px 30px 20px;
  position: absolute;
  width: 100%;
`

export const MonthLabel = styled.span`
  ${fonts.AN_12_500_16}
  color: ${theme.colors.stone};
`

export const TooltipWrapper = styled.div<{ isActive: boolean }>`
  bottom: -50px;
  pointer-events: none;
  position: relative;
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
`

export const Tooltip = styled.div.attrs<Props>((props) => ({
  style: {
    transform: `translateX(${props.offsetX}px)`,
  },
}))<Props>`
  background-color: ${theme.colors.white};
  border-radius: 4px;
  bottom: 0;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
  min-width: 66px;
  opacity: 1;
  padding: 6px 10px;
  pointer-events: none;
  position: absolute;
  transition: opacity 200ms;
  z-index: 1000;
`

export const TooltipContent = styled.div`
  ${fonts.AN_12_500_16}
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const TooltipAccountValue = styled.span`
  color: ${theme.colors.slate};
`

export const TooltipDate = styled.span`
  color: ${theme.colors.stone};
`

export const ArrowDown = styled.div.attrs<Props>((props) => ({
  style: {
    transform: `translate(${props.offsetX}px, 0) rotate(45deg)`,
  },
}))<Props>`
  background-color: ${theme.colors.white};
  bottom: -4px;
  height: 10px;
  left: -5px;
  position: absolute;
  transform: rotate(45deg);
  width: 10px;
`

export const Divider = styled.div.attrs<Props>((props) => ({
  style: {
    transform: `translateX(${props.offsetX}px)`,
  },
}))<Props>`
  pointer-events: none;
  position: absolute;
  width: 1px;
  height: 250px;
  background:
    repeating-linear-gradient(to bottom, transparent 0 4px, #222b2d 4px 8px),
    linear-gradient(to bottom, #fff, transparent);
  background-size: 2px 100%;
  background-position: 80%;
  background-repeat: no-repeat;
`
